import { inject } from 'vue';

/**
 * Vue 3 Composable for Meta Pixel
 * Provides easy access to Meta Pixel tracking functions in components
 */
export function useMetaPixel() {
  const metaPixel = inject('metaPixel');

  if (!metaPixel) {
    console.warn('Meta Pixel not initialized. Make sure to configure metaPixelId in config.');
    return {
      trackEvent: () => {},
      trackPageView: () => {},
      trackConversion: () => {},
      trackLead: () => {},
      trackAddToCart: () => {},
      trackViewContent: () => {},
      trackContact: () => {},
      trackCompleteRegistration: () => {},
      trackStartApplication: () => {},
      trackCompleteApplication: () => {},
      trackSchedule: () => {},
      trackSearch: () => {},
      trackCustomEvent: () => {}
    };
  }

  return {
    // Basic tracking
    trackEvent: (eventName, parameters = {}) => {
      metaPixel.trackEvent(eventName, parameters);
    },
    
    trackPageView: () => {
      metaPixel.trackPageView();
    },

    // Conversion tracking
    trackConversion: (value, currency = 'USD') => {
      metaPixel.trackConversion(value, currency);
    },

    trackLead: (value = 0, currency = 'USD') => {
      metaPixel.trackLead(value, currency);
    },

    // E-commerce tracking
    trackAddToCart: (value, currency = 'USD', contentIds = []) => {
      metaPixel.trackAddToCart(value, currency, contentIds);
    },

    trackViewContent: (value = 0, currency = 'USD', contentIds = []) => {
      metaPixel.trackViewContent(value, currency, contentIds);
    },

    // Engagement tracking
    trackContact: () => {
      metaPixel.trackContact();
    },

    trackCompleteRegistration: () => {
      metaPixel.trackCompleteRegistration();
    },

    // Application tracking
    trackStartApplication: () => {
      metaPixel.trackStartApplication();
    },

    trackCompleteApplication: () => {
      metaPixel.trackCompleteApplication();
    },

    trackSchedule: () => {
      metaPixel.trackSchedule();
    },

    // Search tracking
    trackSearch: (searchString) => {
      metaPixel.trackSearch(searchString);
    },

    // Custom tracking
    trackCustomEvent: (customEventName, parameters = {}) => {
      metaPixel.trackCustomEvent(customEventName, parameters);
    }
  };
} 